export const infoTypeToFieldType = it => {
    switch (it) {
        case "ChoiceField": return "STRING";
        case "DateField": return "DATE";
        case "DateTimeField": return "DATETIME";
        case "DecimalField": return "DECIMAL";
        case "IntegerField": return "INTEGER";
        case "StringField": return "STRING";
        case "TimeField": return "TIME";
        case "TZTimestampField": return "TIME";
        case "InverseAssociationField":
        case "AssociationField":
            return "ASSOCIATION";
        default: throw new Error(`Unknown '${it}' info type`);
    }
};



// WEBPACK FOOTER //
// ./app/data/util/infoTypeToFieldType.js